/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FormulaEvaluateRequest,
    FormulaEvaluateRequestFromJSON,
    FormulaEvaluateRequestToJSON,
} from '../models/FormulaEvaluateRequest';
import {
    type FormulaEvaluateResponse,
    FormulaEvaluateResponseFromJSON,
    FormulaEvaluateResponseToJSON,
} from '../models/FormulaEvaluateResponse';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';

export interface FormulaEvaluateFormulaEvaluatePostRequest {
    /**
     * 
     */
    formulaEvaluateRequest: FormulaEvaluateRequest;
}

export interface FormulaEvaluateZipfileFormulaEvaluateGzipPostRequest {
    /**
     * Gzip-compressed JSON FormulaEvaluateRequest
     */
    file: Blob;
}

/**
 * 
 */
export class PortfolioManagementAPIsApi extends runtime.BaseAPI {

    /**
     * Creates request options for formulaEvaluateFormulaEvaluatePost without sending the request
     */
    async formulaEvaluateFormulaEvaluatePostRequestOpts(requestParameters: FormulaEvaluateFormulaEvaluatePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['formulaEvaluateRequest'] == null) {
            throw new runtime.RequiredError(
                'formulaEvaluateRequest',
                'Required parameter "formulaEvaluateRequest" was null or undefined when calling formulaEvaluateFormulaEvaluatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/formula/evaluate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormulaEvaluateRequestToJSON(requestParameters['formulaEvaluateRequest']),
        };
    }

    /**
     * Formula Evaluate
     */
    async formulaEvaluateFormulaEvaluatePostRaw(requestParameters: FormulaEvaluateFormulaEvaluatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormulaEvaluateResponse>> {
        const requestOptions = await this.formulaEvaluateFormulaEvaluatePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormulaEvaluateResponseFromJSON(jsonValue));
    }

    /**
     * Formula Evaluate
     */
    async formulaEvaluateFormulaEvaluatePost(requestParameters: FormulaEvaluateFormulaEvaluatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormulaEvaluateResponse> {
        const response = await this.formulaEvaluateFormulaEvaluatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for formulaEvaluateZipfileFormulaEvaluateGzipPost without sending the request
     */
    async formulaEvaluateZipfileFormulaEvaluateGzipPostRequestOpts(requestParameters: FormulaEvaluateZipfileFormulaEvaluateGzipPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling formulaEvaluateZipfileFormulaEvaluateGzipPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/formula/evaluate/gzip`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Formula Evaluate Zipfile
     */
    async formulaEvaluateZipfileFormulaEvaluateGzipPostRaw(requestParameters: FormulaEvaluateZipfileFormulaEvaluateGzipPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormulaEvaluateResponse>> {
        const requestOptions = await this.formulaEvaluateZipfileFormulaEvaluateGzipPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormulaEvaluateResponseFromJSON(jsonValue));
    }

    /**
     * Formula Evaluate Zipfile
     */
    async formulaEvaluateZipfileFormulaEvaluateGzipPost(requestParameters: FormulaEvaluateZipfileFormulaEvaluateGzipPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormulaEvaluateResponse> {
        const response = await this.formulaEvaluateZipfileFormulaEvaluateGzipPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
